// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAvailabilityStyles } from "@ces/Overrides/Components/ProductAvailability";
import { color, xScreen } from "@ces/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productAvailabilityStyles.container = {
    ...productAvailabilityStyles.container,
    offsetCss: css`
        row-gap: 4px;
    `,
};
productAvailabilityStyles.errorText = {
    weight: "bold",
    size: 12,
    color: "danger",
    lineHeight: "15px",
};

productAvailabilityStyles.availabilityByWarehouseLink = {
    color: "secondary",
    typographyProps: {
        css: css`
            &&&& {
                line-height: 15px;
            }
        `,
    },
    css: css`
        &:not([disabled]):hover ${TypographyStyle}, &:not([disabled]):focus ${TypographyStyle} {
            color: ${color("common.ui9")};
        }
        margin-left: auto;
    `,
};

productAvailabilityStyles.messageText = {
    size: 12,
    lineHeight: "15px",
    css: css`
        width: 100%;
        ${wrapInContainerStyles}
        letter-spacing: 0;
    `,
};

productAvailabilityStyles.availabilityByWarehouseModal = {};
productAvailabilityStyles.messageGridItem = { width: 6 };
productAvailabilityStyles.availabilityByWarehouseLinkGridItem = { width: 6 };
